import { PageHero } from "@/components/public/Layout";
import { Reveal, SectionLabel } from "@/components/public/shared";
import { useEnquiry } from "@/components/public/EnquiryProvider";
import { IMG } from "@/lib/images";

const EVENTS = [
  { t: "Weddings", d: "Grand banquets, live counters and multi-cuisine feasts.", img: IMG.banquet },
  { t: "Anniversaries", d: "Intimate, elegant celebrations of togetherness.", img: IMG.fineTable },
  { t: "Birthdays", d: "Joyful spreads crafted for every age and theme.", img: IMG.buffet },
  { t: "Kitty Parties", d: "Chic, shareable menus for memorable afternoons.", img: IMG.momoPurple },
  { t: "Corporate Events", d: "Polished dining for teams, clients and partners.", img: IMG.corporate },
  { t: "Conferences", d: "Reliable, high-volume catering that runs on time.", img: IMG.corporateHall },
  { t: "Product Launches", d: "Statement culinary experiences for your brand.", img: IMG.chefPlating },
  { t: "Private Events", d: "Bespoke experiences for your closest circle.", img: IMG.ballroom },
  { t: "Large-Scale Events", d: "Thousands of guests, one seamless operation.", img: IMG.buffetGourmet },
];

export default function Events() {
  const { open } = useEnquiry();
  return (
    <div>
      <PageHero label="Events & Experiences" title="Experiences designed around people, occasions and places." subtitle="From the most intimate gathering to the grandest celebration — crafted entirely in pure vegetarian & Jain-Friendly cuisine." image={IMG.ballroom} />
      <section className="bg-ivory py-20 sm:py-28">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {EVENTS.map((e, i) => (
              <Reveal key={e.t} delay={(i % 3) * 60}>
                <div className="group relative overflow-hidden aspect-[4/5]">
                  <img src={e.img} alt={e.t} loading="lazy" className="absolute inset-0 h-full w-full object-cover transition-transform duration-[1200ms] group-hover:scale-110" />
                  <div className="absolute inset-0 bg-gradient-to-t from-charcoal/90 via-charcoal/30 to-transparent" />
                  <div className="absolute inset-x-0 bottom-0 p-6">
                    <h3 className="font-display text-2xl text-ivory">{e.t}</h3>
                    <p className="mt-2 text-sm text-ivory/75">{e.d}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
          <div className="mt-14 text-center">
            <button data-testid="events-plan-event" onClick={() => open("event")} className="inline-flex items-center gap-2 bg-espresso px-10 py-4 text-[12px] font-semibold uppercase tracking-editorial text-ivory transition-colors hover:bg-gold">
              Plan Your Event
            </button>
          </div>
        </div>
      </section>
    </div>
  );
}
